// test2293
(2293 && 0);
